/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shallowEqual } from 'recompose';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { includeStamp } from 'src/utils/StampUtils';
import { cloneDeep } from 'lodash-es';
import FormikInput from 'src/components/formik/FormikInput';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import FormikCheckBox from 'src/components/formik/FormikCheckBox';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { caseUpsertAction } from '../actions/CaseActions';
import {
    VehicleInsurancePaymentDefaultProps,
    VehicleInsurancePaymentDefaultSchema,
} from '../CasePropTypes';
import VehicleInsurancePaymentList from './VehicleInsurancePaymentList';

function Render(props) {
    const { values } = props;

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <h3>Vehicle Insurance Payment Information</h3>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Instrument Number</label>
                            <FormikInput
                                name="instrument_number"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Bank Name</label>
                            <FormikInput
                                name="bank_name"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Amount</label>
                            <FormikInput
                                name="amount"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Payment Date</label>
                            <FormikDateTimePicker
                                name="payment_date"
                                value={values?.payment_date || ''}
                                className="form-control"
                                disableClock
                                format="dd-MM-y"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Is Paid by Us?</label>

                            <FormikCheckBox
                                className="ml-2 big-checkbox"
                                name="is_paid_by_us"
                            />
                        </div>
                    </div>
                    <PermissionHOC
                        scope="flow.case_manager.vehicle_insurance_payments.submit"
                        component={(
                            <div className="form-row">
                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

Render.propTypes = {
    values: PropTypes.shape({
        payment_date: PropTypes.string,
        instrument_number: PropTypes.string,
        bank_name: PropTypes.string,
        amount: PropTypes.string,
        is_paid_by_us: PropTypes.string,
    }).isRequired,
};

let setSubmitting = () => {};

function VehicleInsurancePaymentsForm() {
    const dispatch = useDispatch();
    const { currentRecord, upsertReqStatus } = useSelector((state) => state.CaseReducer, shallowEqual);

    const approvedQuotation = currentRecord.quotations.find(
        (quotation) => quotation.isApproved,
    );

    // if current record changed or request status changed the enable submit
    usePrevious(
        {
            currentRecord,
            upsertReqStatus,
        },
        (prev) => {
            if (
                prev.currentRecord !== currentRecord
        || (upsertReqStatus
          && prev.upsertReqStatus !== upsertReqStatus
          && upsertReqStatus !== REQUEST_STATUS.PENDING)
            ) {
                setSubmitting(false);
            }
        },
    );

    const removePayment = (record) => {
        const newRecord = cloneDeep(currentRecord);

        newRecord.payments.find((payment) => {
            if (record._id === payment._id) {
                // eslint-disable-next-line no-param-reassign
                payment.deleted = true;
                // eslint-disable-next-line no-param-reassign
                payment.deletedTs = new Date();
                return true;
            }

            return false;
        });

        dispatch(caseUpsertAction(newRecord));
    };

    const onSubmit = (values, formikUtils) => {
        ({ setSubmitting } = formikUtils);
        const newRecord = cloneDeep(currentRecord);

        const {
            payment_date,
            instrument_number,
            bank_name,
            amount,
            is_paid_by_us,
        } = values;

        includeStamp(newRecord);

        newRecord.payments.push(includeStamp({
            payment_date,
            instrument_number,
            bank_name,
            amount,
            is_paid_by_us,
        }));

        dispatch(caseUpsertAction(newRecord));
        formikUtils.resetForm();
    };

    // if (!approvedQuotation) {
    //     return (
    //         <div
    //             className="alert alert-success"
    //             role="alert"
    //         >
    //             There are no approved quotation for this case to add cover note.
    //         </div>
    //     );
    // }

    return (
        <div>

            <Formik
                onSubmit={onSubmit}
                initialValues={{
                    ...VehicleInsurancePaymentDefaultProps,
                }}
                validationSchema={VehicleInsurancePaymentDefaultSchema}
            >
                {(formikProps) => (
                    <Form>
                        <Render {...formikProps} />
                    </Form>
                )}
            </Formik>
            <VehicleInsurancePaymentList
                payments={currentRecord.payments}
                removePayment={removePayment}
            />
        </div>
    );
}

export default VehicleInsurancePaymentsForm;
